var map = {
	"./Airbrake/Description.md": 98822,
	"./Airtable/Description.md": 12417,
	"./Asana/Description.md": 20725,
	"./Axosoft/Description.md": 76809,
	"./AzureDevOps/Description.md": 36601,
	"./Backlog/Description.md": 16112,
	"./Bitbucket/Description.md": 24610,
	"./Breeze/Description.md": 63170,
	"./Bugasura/Description.md": 29949,
	"./Bugherd/Description.md": 79432,
	"./Bugsnag/Description.md": 77544,
	"./Bugzilla/Description.md": 4915,
	"./Clickup/Description.md": 15238,
	"./Datadog/Description.md": 37177,
	"./DevRev/Description.md": 42777,
	"./Favro/Description.md": 49370,
	"./Flock/Description.md": 29122,
	"./FogBugz/Description.md": 99511,
	"./Github/Description.md": 9614,
	"./GithubCopilotChat/Description.md": 86820,
	"./Gitlab/Description.md": 42054,
	"./GoodDay/Description.md": 83830,
	"./GoogleChat/Description.md": 43096,
	"./Hive/Description.md": 20671,
	"./Jira/Description.md": 31969,
	"./LinearApp/Description.md": 26823,
	"./Mantis/Description.md": 69689,
	"./Mattermost/Description.md": 40307,
	"./MicrosoftTeams/Description.md": 67795,
	"./Miro/Description.md": 50276,
	"./Monday/Description.md": 25561,
	"./NewRelic/Description.md": 97264,
	"./Notion/Description.md": 23500,
	"./PagerDuty/Description.md": 27640,
	"./Paymo/Description.md": 91457,
	"./PivotalTracker/Description.md": 15638,
	"./Practitest/Description.md": 23368,
	"./Redmine/Description.md": 11427,
	"./RocketChat/Description.md": 47127,
	"./Shopify/Description.md": 16633,
	"./Shortcut/Description.md": 47727,
	"./Slack/Description.md": 79643,
	"./SumoLogic/Description.md": 67945,
	"./TargetProcess/Description.md": 68037,
	"./Teamwork/Description.md": 59345,
	"./Trello/Description.md": 31971,
	"./Userback/Description.md": 87985,
	"./Webex/Description.md": 56716,
	"./Webhooks/Description.md": 57507,
	"./Wrike/Description.md": 17183,
	"./YouTrack/Description.md": 96151,
	"./Zenkit/Description.md": 47130,
	"./Zipboard/Description.md": 75292,
	"./ZohoBugTracker/Description.md": 88429,
	"./ZohoCliq/Description.md": 9642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74562;